import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Observable,of } from 'rxjs';
import {Configuration} from "./configuration";

@Injectable()
export class HttpService {

  constructor(private http: HttpClient, private _config:Configuration){
    this.setHeaders();
  }

  public makePostReq(request : any, api : String): Observable<any> {
    //  let response = {
    //   "status": "SUCCESS"
    // };
    // return of(response);
//     let res = {
//       errorCode: null,
// errorMessage: null,
// response: null,
// status: "TECHNICAL_ERROR"
//     };
//     return of(res);
    return this.http.post((this._config.ApiUrl + api), request, this.setHeaders());
  }

  public makeGetReq(api : String): Observable<any> {
    return this.http.get((this._config.ApiUrl + api), this.setHeaders());
  }
  
  private setHeaders(){
   let requestHeaders =    {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'}),
      withCredentials: false, //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
    };
    return requestHeaders;
  }
  
}